<template>
  <div id="contenedor-main-listado">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :listadoContratos="listadoContratos"></desktop>
    </template>
    <template v-else>
      <mobile :listadoContratos="listadoContratos"></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListado',
  props: {
    listadoContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
